module.exports = __webpack_public_path__ + "static/media/yoroi.59a50265.svg";